import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { InventariosCabContext } from '../../../context/inventariosCab/InventariosCabContext';
import { Paginator } from '../../../components/paginator/Paginator';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../components/Title";
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid"
import { fetchEntityData } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";

export const Datatable = ({ onSelect, onClose }) => {
  const titleGrid = "Lista de Inventarios"
  useDocumentTitle(titleGrid);
const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(InventariosCabContext);
  const { getInventariosCabPanelData } = contexto;
  const navigate = useNavigate();

  const nameData = "inventarios";
  const descData = "pcia_descripcion";
  const getData = getInventariosCabPanelData;

  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState();
  const [searchIDSel, setSearchIDSel] = useState();
  const [searchDescSel, setSearchDescSel] = useState();
  const [searchIDDepo, setSearchIDDepo] = useState();
  const [searchDescDepo, setSearchDescDepo] = useState();
  const [dateFrom, setDateFrom] = useState("");
  const [dateUntil, setDateUntil] = useState("");
  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalDataItems, setTotalDataItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Ref para busqueda
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
//Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "inventarios";
  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchTerm: "",
    searchIDSel: "",
    searchDescSel: "",
    searchIDDepo: "",
    searchDescDepo: "",
    dateFrom: "",
    dateUntil: ""
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchTerm(savedFilters.searchTerm || "");
      setSearchIDDepo(savedFilters.searchIDDepo || "");
      setSearchDescDepo(savedFilters.searchDescDepo || "");
      setSearchIDSel(savedFilters.searchIDSel || "");
      setSearchDescSel(savedFilters.searchDescSel || "");
      setDateFrom(savedFilters.dateFrom || "");
      setDateUntil(savedFilters.dateUntil || "");
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, searchTerm,searchIDSel, searchIDDepo, dateFrom, dateUntil, numPagina, filas]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchTerm,
      searchIDDepo,
      searchDescDepo,
      searchIDSel,
      searchDescSel,
      dateFrom,
      dateUntil
    };
    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage, totalDataItems } = await fetchEntityData(
        getData,
        searchIDSel || "",
        searchIDDepo || "",
        searchTerm || null,
        dateFrom || "",
        dateUntil || "",
        numPagina,
        filas
      );
        setListaItems(dataEntity);
        setTotalItems(totalItems);
        setTotalDataItems(totalDataItems);

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };


  const handleSearch = () => {
    const value = searchInputRef.current?.value || "";
    setSearchTerm(value); 
  };

  const handleClear = () => {
    setSearchTerm(null);
    if (searchInputRef.current) {
      searchInputRef.current.value = null; // Limpia el input de búsqueda
    }
  };

  const getDynamicValue = (row, key) => {
    return row[key];
  };
  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };
  const handleRowClick = (params) => {
    const selectedId = params.row.id; // Capturar el id del Cliente 
    const selectedDesc = getDynamicValue(params.row, descData);
    onSelect && onSelect(selectedId, selectedDesc); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };


  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden));
    return onSelect ? commonCols : commonCols.concat(getActionColumn(handleClickEdit, null, false));
  }, [onSelect, numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);
 

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h3>{titleGrid}</h3>
          <div className="linkContainer">
            <Link to={`/${nameData}/new`} className="link">Agregar</Link>
          </div>
          <FiltersGrid
            searchInputRef={searchInputRef}
            searchTerm={searchTerm}
            searchDescFilter={searchDescSel}
            searchDescSecondFilter={searchDescDepo}
            dateFromFilter={dateFrom}
            dateUntilFilter={dateUntil}
            setSearchTerm={setSearchTerm}
            setSearchIDFilter={setSearchIDSel}
            setSearchDescFilter={setSearchDescSel}
            setSearchIDSecondFilter={setSearchIDDepo}
            setSearchDescSecondFilter={setSearchDescDepo}
            setDateFromFilter={setDateFrom}
            setDateUntilFilter={setDateUntil}
            onSearch={handleSearch}
            onClose={handleClear}
          />
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onRowClick={handleRowClick}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalDataItems}
            />
          </div>

        </>

      )}
    </div>
  );
};

export default Datatable;
